import { template6PlaceholderData, TemplateProps } from '@zeus/shared';
import useFont from '../../../hooks/useFont';
import { forwardRef, useEffect, useRef } from 'react';
import Menu from './components/menu';
import Media from '../Media';
import { getScaleSize } from '../../../utils/utils';
import { useNormalizedPixels } from '../../../hooks/useResize';
import { TypographyComponent } from '../../../base/typography/Typography';
import { BoxComponent } from '../../../base/box/Box';

export const Template6 = forwardRef<HTMLDivElement, TemplateProps>((props, ref) => {
  const { template, scale = 1, style, development, timezone, tenantId, active, shouldLoad = true } = props;
  const mainRef = useRef<HTMLDivElement>(null);
  const sizeRef = useRef<{ width: number; height: number }>({ width: 0, height: 0 });
  const { normalizePixels } = useNormalizedPixels();

  useFont(template?.fontFamily);

  useEffect(() => {
    if (mainRef.current) {
      sizeRef.current = {
        width: mainRef.current.offsetWidth,
        height: mainRef.current.offsetHeight,
      };
      mainRef.current.style.backgroundSize = `${sizeRef.current.width}px ${sizeRef.current.height}px`;
    }
  }, [style?.width, style?.height]);

  const bgStyles = () => {
    if (template?.background?.isEnabled && template?.background?.image) {
      return { backgroundImage: `url(${template?.background?.image})` };
    }

    if (template?.background?.color) {
      return { backgroundColor: template?.background?.color };
    }

    return {
      backgroundImage: `url(https://dashboard-demo-assests.s3.us-west-2.amazonaws.com/dashboard/menuboard/Template6.webp)`,
    };
  };

  const { content, ...rest } = template;
  const menu =
    Array.isArray(template?.content) && template?.content?.length > 0 ? template?.content[0] : template6PlaceholderData;
  const media = template?.media?.mediaContent;
  const isMedia = template.media?.isEnabled && media?.url;

  return (
    <div
      id="template6"
      ref={mainRef}
      style={{
        padding: isMedia ? '0px' : '3% 5% 1.5%',
        overflow: 'hidden',
        display: 'flex',
        flexFlow: 'column',
        backgroundRepeat: 'no-repeat',
        justifyContent: 'space-between',
        position: 'relative',
        ...bgStyles(),
        ...(!style ? { height: '100vw', width: '100vh' } : style),
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'column',
          width: '100%',
          flex: 1,
          overflow: 'hidden',
          position: 'relative',
          padding: isMedia ? '3% 5% 6%' : '0px 0px 5%',
        }}
      >
        <Menu
          ref={ref}
          menu={menu}
          template={rest}
          development={development}
          timezone={timezone}
          scale={scale}
          tenantId={tenantId}
        />

        {template.taxLabel.isEnabled && (
          <BoxComponent sx={{ position: 'absolute', left: isMedia ? '5%' : '0', bottom: isMedia ? '1%' : '0%' }}>
            <TypographyComponent
              sx={{ fontWeight: '500', fontSize: normalizePixels(12, 'height') }}
              variant="subtitle1"
            >
              {template.taxLabel.taxText}
            </TypographyComponent>
          </BoxComponent>
        )}
      </div>
      {isMedia && (
        <div style={{ height: getScaleSize(normalizePixels(390, 'height'), scale) }}>
          <Media
            isDevelopment={development}
            media={media}
            height="100%"
            borderRadius="0px"
            playing={active}
            shouldLoad={shouldLoad}
          />
        </div>
      )}
    </div>
  );
});
